import { Vue, Component, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
@Component({
    name: 'data-access',
    components: {
        'material-icons': GoogleMaterialIcon,
        'add-popup': () => import('../provider-add/provider-add.vue'),
        'provider-table': () => import('../provider-table/provider-table.vue'),
    },
})

export default class DataAccess extends Vue {

    // ----------------------------------------------------------
    // Properties

    private activeComponent: any = 'provider-table';

    // ------------------------------------------------------------------
    // Actions

    public swithComponent(activeComp: any) {
        this.activeComponent = activeComp;
    }


}
